
import { useCallback, useState } from "react";
import { ReportSortBy, SortOrder } from "./types";

interface FilterActionsProps {
  category?: string;
  sortBy?: ReportSortBy;
  sortOrder?: SortOrder;
  pageSize?: number;
}

export const useFilterActions = (initialFilters: FilterActionsProps = {}) => {
  // State for filters and pagination
  const [selectedCategory, setSelectedCategory] = useState(initialFilters.category || "");
  const [sortBy, setSortBy] = useState<ReportSortBy>(initialFilters.sortBy || "date");
  const [sortOrder, setSortOrder] = useState<SortOrder>(initialFilters.sortOrder || "desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(initialFilters.pageSize || 6);
  const [isHovering, setIsHovering] = useState(false);

  // Handle filter changes
  const handleCategoryChange = useCallback((category: string) => {
    setSelectedCategory(category);
    setCurrentPage(1);
  }, []);

  const handleSortChange = useCallback((newSortBy: ReportSortBy, newSortOrder: SortOrder) => {
    setSortBy(newSortBy);
    setSortOrder(newSortOrder);
    setCurrentPage(1);
  }, []);

  const handleItemsPerPageChange = useCallback((newItemsPerPage: number) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  }, []);

  // Change the parameter type to match with what's expected in the Pagination component
  const handlePaginationHover = useCallback((direction: "next" | "previous") => {
    // We're only interested in whether pagination hover is active, regardless of direction
    setIsHovering(true);
    
    // Reset hover state after a short delay
    setTimeout(() => {
      setIsHovering(false);
    }, 300);
  }, []);

  return {
    selectedCategory,
    setSelectedCategory,
    sortBy,
    setSortBy,
    sortOrder,
    setSortOrder,
    currentPage, 
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    isHovering,
    filterState: {
      selectedCategory,
      sortBy,
      sortOrder,
      currentPage,
      itemsPerPage,
      isHovering
    },
    handleCategoryChange,
    handleSortChange,
    handleItemsPerPageChange,
    handlePaginationHover
  };
};
